import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { PaginatedResponse } from '../common/models/common.model';
import { Order, OrderShipmentReqBody, Transporter, Shipment, OrderItem } from './orders.models';
import { buildHttpParams } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private baseUrl: string = 'orders';

  constructor(private apiService: ApiService) {}

  get(params = {}): Observable<PaginatedResponse<Transporter>> {
    const q = buildHttpParams(params);
    return this.apiService.get(this.baseUrl + '/transporters/', q);
  }

  update_transporter(id: string, reqBody: any) {
    return this.apiService.patch(this.baseUrl + `/transporters/${id}/`, reqBody);
  }

  delete_transporter(id: string) {
    return this.apiService.delete(this.baseUrl + `/transporters/${id}/`);
  }

  post_transporter(reqBody: any) {
    return this.apiService.post(this.baseUrl + '/transporters/', reqBody);
  }

  get_orders(params = {}): Observable<PaginatedResponse<Order>> {
    const q = buildHttpParams(params);
    return this.apiService.get(`${this.baseUrl}/`, q);
  }

  get_shipments(params = {}): Observable<PaginatedResponse<any>> {
    const q = buildHttpParams(params);
    return this.apiService.get(this.baseUrl + '/shipments/', q);
  }

  get_order(id: string): Observable<Order> {
    return this.apiService.get<Order>(`${this.baseUrl}/${id}/`);
  }

  download_receipt(id: string): Observable<Blob> {
    return this.apiService.get(`${this.baseUrl}/${id}/download_receipt/`, undefined);
  }

  /** Creates one shipment carrying every line in `reqBody.items`. Answers with the shipment. */
  create_shipment(reqBody: OrderShipmentReqBody): Observable<Shipment> {
    return this.apiService.post<Shipment>(`${this.baseUrl}/items/ship/`, reqBody);
  }

  get_shipment(id: string): Observable<Shipment> {
    return this.apiService.get<Shipment>(`${this.baseUrl}/shipments/${id}/`);
  }

  update_shipment(id: string, reqBody: any): Observable<Shipment> {
    return this.apiService.patch<Shipment>(`${this.baseUrl}/shipments/${id}/`, reqBody);
  }

  update_shipment_status(id: string, reqBody: { status: string; delivery_date?: string }) {
    return this.apiService.patch<Shipment>(`${this.baseUrl}/shipments/${id}/update_status/`, reqBody);
  }

  cancel_item(id: string): Observable<OrderItem> {
    return this.apiService.patch(`${this.baseUrl}/items/${id}/cancel/`);
  }

  exportTotal(params = {}): Observable<HttpResponse<Blob>> {
    const q = buildHttpParams(params);
    return this.apiService.getBlobResponse(`${this.baseUrl}/export-total/`, q);
  }

  exportPending(params = {}): Observable<HttpResponse<Blob>> {
    const q = buildHttpParams(params);
    return this.apiService.getBlobResponse(`${this.baseUrl}/export-pending/`, q);
  }

  exportDispatched(params = {}): Observable<HttpResponse<Blob>> {
    const q = buildHttpParams(params);
    return this.apiService.getBlobResponse(`${this.baseUrl}/shipments/export-dispatched/`, q);
  }
}
